import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Info из макета: контурный круг с восклицательным знаком
export function AppIconInfoOutline({ size = 24, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_ICON_BRAND

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        fill={fill}
        d="M16.2222 10C16.2222 6.56356 13.4365 3.77778 10 3.77778C6.56356 3.77778 3.77778 6.56356 3.77778 10C3.77778 13.4365 6.56356 16.2222 10 16.2222C13.4365 16.2222 16.2222 13.4365 16.2222 10ZM9.11111 13.6444V10.5759C8.66677 10.5268 8.32137 10.151 8.3213 9.69352C8.3213 9.2026 8.71927 8.80463 9.21019 8.80463H10C10.4909 8.80463 10.8889 9.2026 10.8889 9.69352V13.6444C10.8886 14.1352 10.4908 14.5333 10 14.5333C9.50923 14.5333 9.11135 14.1352 9.11111 13.6444ZM18 10C18 14.4183 14.4183 18 10 18C5.58173 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58173 18 10Z"
      />
      <Path
        fill={fill}
        d="M10 5.86347C9.67278 5.86347 9.40745 6.12879 9.40745 6.45607C9.40745 6.78334 9.67278 7.04866 10 7.04866C10.3273 7.04866 10.5926 6.78334 10.5926 6.45607C10.5926 6.12879 10.3273 5.86347 10 5.86347Z"
      />
      <Path
        fill={fill}
        d="M8.81486 6.45607C8.81486 5.8015 9.3455 5.27088 10 5.27088C10.6546 5.27088 11.1852 5.8015 11.1852 6.45607C11.1852 7.11063 10.6546 7.64125 10 7.64125C9.3455 7.64125 8.81486 7.11063 8.81486 6.45607Z"
      />
    </Svg>
  )
}
